
import PercentageSquare from "../../../assets/outline/PercentageSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PercentageSquareIcon({ className, dataTestid = "PercentageSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <PercentageSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
